import {
	MERCHANT_FETCH,
	MERCHANT_FETCH_SUCCESS,
	MERCHANT_FETCH_FAIL,
	CHANGE_SELECT_MERCHANT,
	CLEAR_FILTER_ALL,
	MERCHANT_SUMMARY_FETCH,
	MERCHANT_SUMMARY_FETCH_SUCCESS,
	MERCHANT_SUMMARY_FETCH_FAIL,
	CREATE_NEW_MERCHANT,
	CREATE_NEW_MERCHANT_SUCCESS,
	CREATE_NEW_MERCHANT_FAIL,
	LOAD_MERCHANT,
	LOAD_MERCHANT_SUCCESS,
	LOAD_MERCHANT_FAIL,
	UPDATE_MERCHANT,
	UPDATE_MERCHANT_SUCCESS,
	UPDATE_MERCHANT_FAIL,
} from '../actions';

const INIT_STATE = {
	merchant: [],
	loading: false,
	error: '',
	merchantId: '',
	merchantSummary: 0,
	saveMerchantLoading: false,
	saveMerchantError: '',
	MerchantLoading: false,
	merchantDetail: [],
	loadMerchantError: '',
	profile: '',
};

export default (state = INIT_STATE, action) => {

	switch (action.type) {
		case MERCHANT_FETCH:
			return { ...state, loading: true, error: '' };
		case MERCHANT_FETCH_SUCCESS:
			return { ...state, loading: false, merchant: action.payload, error: '' };
		case MERCHANT_FETCH_FAIL:
			return { ...state, loading: false, merchant: [], error: action.payload.message, totalAmount: 0 };

		case CHANGE_SELECT_MERCHANT:
			return { ...state, merchantId: action.payload };
		case CLEAR_FILTER_ALL:
			return { ...state, merchantId: '' };

		case MERCHANT_SUMMARY_FETCH:
			return { ...state, loading: true, error: '' };
		case MERCHANT_SUMMARY_FETCH_SUCCESS:
			return { ...state, loading: false, merchantSummary: action.payload.merchantSummary, error: '' };
		case MERCHANT_SUMMARY_FETCH_FAIL:
			return { ...state, loading: false, merchantSummary: 0, error: action.payload.message, totalAmount: 0 };

		case CREATE_NEW_MERCHANT:
			return { ...state, saveMerchantLoading: true, saveMerchantError: '', saveType: '' };
		case CREATE_NEW_MERCHANT_SUCCESS:
			return { ...state, saveMerchantLoading: false, merchantCreate: action.payload.merchantCreate, saveMerchantError: '', typeAlert: 'Create Merchant' };
		case CREATE_NEW_MERCHANT_FAIL:

			return { ...state, saveMerchantLoading: false, merchantCreate: [], saveMerchantError: action.payload.message };

		case LOAD_MERCHANT:
			return { ...state, MerchantLoading: true, loadMerchantError: '', saveType: '' };
		case LOAD_MERCHANT_SUCCESS:
			return { ...state, MerchantLoading: false, merchantDetail: action.payload, loadMerchantError: '' };
		case LOAD_MERCHANT_FAIL:
			return { ...state, MerchantLoading: false, merchantDetail: [], loadMerchantError: action.payload.Message };

		case UPDATE_MERCHANT:
			return { ...state, saveMerchantLoading: true, saveMerchantError: '', saveType: '' };
		case UPDATE_MERCHANT_SUCCESS:
			return { ...state, saveMerchantLoading: false, profile: action.payload.merchantUpdate, saveMerchantError: '', typeAlert: 'Update Merchant' };
		case UPDATE_MERCHANT_FAIL:
			console.log(action.payload);
			return { ...state, saveMerchantLoading: false, profile: [], saveMerchantError: action.payload.message };

		default: return { ...state };
	}
}
